import React, { useState } from "react";
import WIIASCEND from "../assets/images/wiiascend.png";
import B3 from "../assets/images/b3.png";
import FCA from "../assets/images/fca.png";
import BLOCKCHAIN from "../assets/images/blockchain.png";
import ANBINA from "../assets/images/anbina.png";
import Icon from "./icons/Icon";
import Contact from "../pages/Contact";
import { Link } from "react-router-dom";
import PdfModal from "./PdfModal";
import ABACP from "../assets/pdfs/Publicas/Anti-Bribery.pdf";
import DDP from "../assets/pdfs/Publicas/DueDiligencePolicy.pdf";
import ISCP from "../assets/pdfs/Publicas/CybersecurityPolicy.pdf";
import SCEC from "../assets/pdfs/Publicas/CodeEthicsConduct.pdf";
import DPL from "../assets/pdfs/Publicas/DataProtectionLaw.pdf";

const policies = [
  { title: "Anti-Bribery and Anti-Corruption Policy", url: ABACP },
  { title: "Due Diligence Policy", url: DDP },
  { title: "Information Security and Cybersecurity Policy", url: ISCP },
  { title: "Supplier Code of Ethics and Conduct", url: SCEC },
  { title: "The General Data Protection Law", url: DPL },
];

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const [open, setOpen] = useState(false);
  const [currentPdf, setCurrentPdf] = useState(null);

  // function handleClick(name) {
  //   setCurrentPdf(LICENSES[name]);
  //   setOpen(true);
  // }

  function handleClose() {
    setOpen(false);
    setCurrentPdf(null);
  }

  return (
    <>
      <div className="bg-[#02000E] p-20 text-white w-full lg:min-w-[1024px] flex-row">
        <div className="flex flex-col lg:flex-row justify-between items-start gap-4">
          <div className="justify-between flex-col">
            <img
              src={WIIASCEND}
              alt="WIIASCEND"
              className="w-[150px] h-auto rounded-xl"
            />

            <div className="flex flex-col items-center mb-6 mt-6 md:mb-0">
              {/* <button
                onClick={openModal}
                className="bg-transparent border border-[#0E2D60] w-55 text-white text-xl py-2 px-6 rounded-full hover:bg-[#0E2D60]"
              >
                Entre em contato
              </button> */}
              <ul className="text-white/60 text-xl justify-start items-start flex flex-col gap-y-2">
                <div className="flex flex-row gap-2 items-center justify-center">
                  <Icon name="WhatsappP" className="w-5 h-5 mb-2" />
                  <li className="mb-2 ">+55 48 99108-1427</li>
                </div>
                {/* <div className="flex flex-row gap-2 items-center justify-center">
                  <Icon name="WhatsappP" className="w-5 h-5 mb-2" />
                  <li className="mb-2 ">+55 11 92058-1944</li>
                </div> */}
                <div className="flex flex-row gap-2 items-center justify-center">
                  <Icon name="EmailP" className="w-5 h-5 mb-2" />
                  <li className="mb-2 ">contato@wiiascend.com</li>
                </div>
                <div className="flex flex-row  gap-2 items-center justify-center">
                  <Icon name="LocalizationPin" className="w-5 h-5 mb-2" />
                  <li className="mb-2 justify-start w-[250px] text-left">
                    Endereço: Av. Pref. Osmar Cunha, nº 416, Centro,
                    Florianópolis - SC / Brasil, CEP 88015-100
                  </li>
                </div>
              </ul>
            </div>
          </div>

          <div className="flex flex-col justify-between md:mb-0">
            <h3 className="text-white text-2xl flex flex-col mb-4">Páginas</h3>
            <ul className="text-white/60 text-xl justify-center flex flex-col gap-y-2">
              <div className="mb-2">
                <li>
                  <Link to="/we" className="text-white/60 text-xl ">
                    Sobre nós
                  </Link>
                </li>
              </div>
              {/* <div className="mb-2">
                <li>
                  <Link to="/cripto" className="text-white/60 text-xl ">
                    Internet Banking
                  </Link>
                </li>
              </div> */}
              <div className="mb-2">
                <li>
                  <Link to="/cripto" className="text-white/60 text-xl ">
                    Exchange
                  </Link>
                </li>
              </div>
              <div className="mb-2">
                <li>
                  <Link to="/token" className="text-white/60 text-xl ">
                    Investimentos
                  </Link>
                </li>
              </div>
            </ul>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-start">
            <div className="flex flex-col md:mb-0 justify-center">
              <h3 className="text-2xl font-normal mb-4">
                Políticas institucionais
              </h3>
              <ul className="text-white/60 text-xl flex flex-col gap-y-4">
                {policies.map(({ title, url }) => (
                  <li key={title}>
                    <a
                      href={url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline text-white/60 text-xl"
                    >
                      {title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="flex flex-row mb-6 md:mb-0">
            <button
              onClick={scrollToTop}
              className="flex flex-row text-2xl justify-center items-center gap-2 bg-transparent text-white py-0 px-6 border-none hover:text-primary hover:border-none"
            >
              Voltar ao topo
              <Icon name="ArrowTop" className="w-4 h-4" />
            </button>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row justify-center items-center text-sm mt-8">
          <div className="m-2">
            <img
              src={ANBINA}
              alt="ANBINA"
              className="w-[220px] h-[40px] mr-20 "
            />
          </div>
          <div className="flex flex-row ">
            <div className="m-2">
              <img
                src={BLOCKCHAIN}
                alt="BLOCKCHAIN"
                className="w-[100px] h-[40px] mr-20"
              />
            </div>
            <div className="m-2">
              <img src={FCA} alt="FCA" className="w-[100px] h-[40px] mr-20" />
            </div>
          </div>
          <div className="flex  m-2 items-center justify-center">
            <img src={B3} alt="B3" className="w-[100px] h-[40px] mr-20" />
          </div>
        </div>

        <hr className="my-4 mb-4" />

        <div className=" justify-start text-xs mt-8">
          <p className=" text-[#FAFAFA]/60 font-light text-justify">
            {" "}
            Toda comunicação através da rede mundial de computadores está
            sujeita a interrupções ou atrasos, podendo prejudicar ordens,
            negociações ou a recepção de informações atualizadas. A Wii Ascend,
            exime-se de responsabilidade por danos sofridos por seus clientes,
            por força de falha de serviços disponibilizados por terceiros,
            incluindo, sem limitação aqueles conexos à rede mundial de
            computadores. Todos os elementos que compõem este site, incluindo,
            mas não se limitando, as suas marcas, sinais de propaganda, textos,
            fotos e outras imagens, são propriedade e objeto de direitos
            exclusivos de seus respectivos titulares e/ou licenciados. A
            reprodução destes elementos sem prévia autorização dos respectivos
            proprietários e/ou licenciados constitui ou pode vir a constituir
            violação de propriedade intelectual, sujeitando os infratores às
            penalidades cabíveis na legislação civil e penal. Caso tenha
            interesse em utilizar algum dos elementos contidos neste site, entre
            em contato com a Wii Ascend - CNPJ: 59.554.586/0001-89.
          </p>
        </div>

        <div className="flex  justify-center items-center text-sm mt-8 ">
          <p className="text-base text-[#FAFAFA]/60 font-light">
            Copyright © 2025 Wii Ascend Technologies
          </p>
        </div>
      </div>

      {open && currentPdf && (
        <PdfModal src={currentPdf} onClose={handleClose} />
      )}

      <Contact isOpen={isModalOpen} closeModal={closeModal} />
    </>
  );
};

export default Footer;
